import { render, staticRenderFns } from "./AlertChoiceCategorySession.vue?vue&type=template&id=3248a8fc&scoped=true&"
import script from "./AlertChoiceCategorySession.vue?vue&type=script&lang=js&"
export * from "./AlertChoiceCategorySession.vue?vue&type=script&lang=js&"
import style0 from "./AlertChoiceCategorySession.vue?vue&type=style&index=0&id=3248a8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248a8fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow})
